import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { Icon } from '../icon/Icon';
import styled from 'styled-components';

type Props = {
	className?: string;
	direction?: 'left' | 'right';
	color?: string;
	caret?: React.ReactNode;
	icon?: string;
	size?: 'xs' | 'sm' | 'lg';
};

const ButtonContent = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 8px;
`;

export const DropdownMenu = ({
	className,
	children,
	direction = 'left',
	color = 'white',
	size,
	caret,
	icon,
}: PropsWithChildren<Props>) => (
	<>
		<button
			type="button"
			className={classNames(
				'btn dropdown-toggle',
				className,
				{ [`btn-${size}`]: size, [`btn-${color}`]: color }
			)}
			data-toggle="dropdown"
			aria-haspopup="true"
			aria-expanded="false"
		>
			<ButtonContent>
				{caret || <span className="caret" />}
				{icon && <Icon name={icon} />}
			</ButtonContent>
		</button>

		<ul className={`dropdown-menu pull-${direction}`}>
			{children}
		</ul>
	</>
);
